var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "79px",
    viewBox: "0 0 79 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "45DB0B25-5B2B-448A-B440-AC39B51B2D6F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.379021805 78.6209188 0.379021805 78.6209188 79 0 79"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hospitalization-desktop",
    transform: "translate(-224.000000, -2278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(224.000000, 2278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6209188,39.6895406 C78.6209188,61.400285 61.0205504,79.0000594 39.3104,79.0000594 C17.6002496,79.0000594 -0.000118796992,61.400285 -0.000118796992,39.6895406 C-0.000118796992,17.9787962 17.6002496,0.379021805 39.3104,0.379021805 C61.0205504,0.379021805 78.6209188,17.9787962 78.6209188,39.6895406",
    id: "Fill-1",
    fill: "#3A913F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.8814623,24 C48.9567947,24.1703605 49,24.3567423 49,24.5538051 C49,25.352737 48.3286558,26 47.5,26 C46.6718981,26 46,25.352737 46,24.5538051 C46,24.3567423 46.0437592,24.1703605 46.1190916,24",
    id: "Stroke-4",
    stroke: "#FFFFFF",
    strokeWidth: 1.17,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,25 L47.5,21",
    id: "Stroke-6",
    stroke: "#FFFFFF",
    strokeWidth: 1.17,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3474294,22 L52.9057729,22 C54.0622039,22 55,22.8984996 55,24.0064725 L55,37.9935275 C55,39.1015004 54.0622039,40 52.9057729,40 L43.0942271,40 C41.9384102,40 41,39.1015004 41,37.9935275 L41,24.0064725 C41,22.8984996 41.9384102,22 43.0942271,22 L46.6519565,22",
    id: "Stroke-8",
    stroke: "#FFFFFF",
    strokeWidth: 1.17,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,37 L33,37 L33,36.1541534 C33,35.3041134 32.3504551,34.5822684 31.4752525,34.4600639 L28,34 L28,37 Z",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,37 L33,37 L33,36.1541534 C33,35.3041134 32.3504551,34.5822684 31.4752525,34.4600639 L28,34 L28,37 Z",
    id: "Stroke-12",
    stroke: "#FFFFFF",
    strokeWidth: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,22.0319545 L32.0820616,22 C31.2068777,22.0005917 30.3475848,22.5136384 29.9002817,23.3379452 L27.6149157,27.5512004 C27.3018035,28.1275642 26.7014756,28.4861643 26.047589,28.4861643 L24.4808509,28.4861643 C24.2154118,28.4861643 24,28.7027446 24,28.9702153 L24,30.5975259 C24,30.7999042 24.1259511,30.9815712 24.316055,31.0513977 L24.9240341,31.3993463 C25.3536806,31.645514 25.6191197,32.1041197 25.6191197,32.6005974 L25.6191197,41.0111305 C25.6191197,42.110009 26.5043091,43 27.5960819,43 L28.7013915,43 C29.7937529,43 30.6789423,42.110009 30.6789423,41.0117223 L30.6789423,39.900417 L37.6768823,39.900417",
    id: "Stroke-14",
    stroke: "#FFFFFF",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,40.5 L29,40.5",
    id: "Stroke-16",
    stroke: "#FFFFFF",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,36.5 L38,36.5",
    id: "Stroke-18",
    stroke: "#FFFFFF",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5488823,24.5813304 L29.3040853,28.5612074 C29.2156346,28.7177194 29.1127312,28.863611 29,29 L38,29 L38,24 L32.5623073,24 C32.1397097,24 31.7517986,24.2224707 31.5488823,24.5813304",
    id: "Fill-20",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5488823,24.5813304 L29.3040853,28.5612074 C29.2156346,28.7177194 29.1127312,28.863611 29,29 L38,29 L38,24 L32.5623073,24 C32.1397097,24 31.7517986,24.2224707 31.5488823,24.5813304 Z",
    id: "Stroke-22",
    stroke: "#FFFFFF",
    strokeWidth: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7350199,33.2653767 L48.9901078,33.2653767 C49.2983054,33.2653767 49.5690424,33.1874756 49.802319,33.0310601 C50.0355956,32.8746445 50.2166545,32.6525958 50.3449282,32.3649138 C50.4737696,32.0772319 50.5373388,31.7472258 50.5373388,31.374282 C50.5373388,30.9958178 50.4737696,30.6633581 50.3449282,30.3756761 C50.2166545,30.0879942 50.0355956,29.8647187 49.802319,29.7058496 C49.5690424,29.5469804 49.2983054,29.4678526 48.9901078,29.4678526 L45.7350199,29.4678526 L45.7350199,28 L48.9407281,28 C49.5480418,28 50.0821374,28.1404673 50.545285,28.4201751 C51.0061623,28.6998829 51.3643071,29.0942954 51.6185843,29.6040261 C51.8728614,30.1131434 52,30.7032287 52,31.374282 C52,32.0453354 51.8728614,32.6341939 51.6185843,33.1408576 C51.3643071,33.6475213 51.0061623,34.0400937 50.545285,34.3173479 C50.0821374,34.5946021 49.5480418,34.7332292 48.9407281,34.7332292 L45.7350199,34.7332292 L45.7350199,33.2653767 Z M45,39 L46.4291738,39 L46.4291738,28 L45,28 L45,39 Z",
    id: "Fill-24",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,22 L38,20 L34.7715796,20 C33.7974163,20 33,20.8621347 33,21.9161372",
    id: "Stroke-26",
    stroke: "#FFFFFF",
    strokeWidth: 1.206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.268952,61 C43.2588968,61 43.2494331,61 43.2393779,60.9987826 C41.6494737,60.94339 38.2685614,59.6279695 34.3399366,58.0441081 C33.0564202,57.5267053 31.948574,57.0805215 31.4943157,56.9490403 C31.134103,56.8437336 30.9235353,56.4572033 31.0258617,56.0877168 C31.1281882,55.7157955 31.5020049,55.4997037 31.8628091,55.6050104 C32.3809475,55.7541442 33.4639514,56.1924148 34.8338242,56.7432966 C37.6078758,57.8627128 41.8003017,59.5512721 43.2742753,59.6036211 L43.2949772,59.6036211 C45.3864583,59.6036211 54.7419324,54.2500237 56.3448492,51.295958 C56.6908663,50.6592482 56.6435477,50.4328084 56.6423647,50.4297648 C55.8385404,49.7778373 49.6001776,52.3770255 48.5786878,53.171391 C48.2835382,53.4020918 47.8547136,53.3497428 47.6269929,53.0459969 C47.3998637,52.7428598 47.4465908,52.3131111 47.738783,52.0744971 C48.0445793,51.8261437 55.6415768,47.7295308 57.5431921,49.3986115 C57.9714253,49.7747937 58.3156679,50.5253322 57.5301795,51.9758862 C55.6427598,55.4552679 45.8241551,61 43.268952,61",
    id: "Fill-28",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5265955,55 C45.1368095,55 44.72895,54.9623813 44.3144635,54.8841101 L43.2866815,54.6741735 C41.5245114,54.3204363 39.8605409,53.9861153 37.9778805,53.3902836 C37.6139999,53.2737869 37.4115763,52.8842513 37.5266445,52.5165589 C37.6411102,52.1506866 38.027884,51.9522783 38.3929695,52.0608872 C40.2039381,52.6360893 41.7582625,52.9479604 43.5571822,53.3089786 L44.5831568,53.517095 C46.3634004,53.8617309 47.5020334,53.1930888 47.612282,52.7392373 C47.692408,52.4164446 47.1845415,51.7459822 45.4639406,51.2217474 C42.5336174,50.3073702 40.8274753,49.0441099 39.457501,48.0284049 C38.5718975,47.3731114 37.8724515,46.8543373 37.0766134,46.5934334 C35.0782823,45.9702978 32.0160223,46.8500901 30.0188962,47.9343582 C29.6827284,48.1224517 29.2634222,47.991393 29.0826868,47.6534314 C28.9019514,47.3142563 29.0272613,46.8937763 29.3634292,46.7111436 C31.6810594,45.4539508 35.0933436,44.518944 37.4959195,45.266464 C38.5122548,45.6013918 39.3291788,46.2063248 40.2756298,46.9065181 C41.6299404,47.9094813 43.1649864,49.0459302 45.8687879,49.892351 C49.2039584,50.9062357 49.0750338,52.5839085 48.9539411,53.0723449 C48.6659693,54.2543002 47.2568357,55 45.5265955,55",
    id: "Fill-30",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5808531,47.9556987 L26.7929305,57.5487212 L29.4187869,57.0418152 L27.2073402,47.4482141 L24.5808531,47.9556987 Z M26.2334459,59 C25.8991427,59 25.5982699,58.7853172 25.5257325,58.4734196 L23.015936,47.5813058 C22.9755673,47.4088652 23.0127822,47.2277447 23.1174885,47.0813438 C23.2221947,46.9332069 23.3868232,46.8307841 23.5741591,46.7931712 L27.6167039,46.0142951 C28.0065139,45.9390693 28.3906471,46.1682186 28.4739075,46.5258303 L30.9843347,57.4179441 C31.0240726,57.5892274 30.9874885,57.7691906 30.8827823,57.9167488 C30.778076,58.0648857 30.6134475,58.1673085 30.4254808,58.2037641 L26.3823054,58.9861122 C26.3324753,58.9947921 26.2820144,59 26.2334459,59 L26.2334459,59 Z",
    id: "Fill-32",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.38e3381615ee7d9c5e94140fc080202e.svg";
export { ForwardRef as ReactComponent };